import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import ThemeProviderWrapper from "../components/ThemeProviderWrapper";
import { ThemeModeProvider } from "../components/ThemeModeContext";

const UnauthorizedPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <ThemeModeProvider>
      <ThemeProviderWrapper>
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            overflow: "hidden",
            background: `linear-gradient(135deg, #2b2b2b, #1c1c1c)`,
            color: "#fff",
            p: 3,
          }}
        >
          {/* Linhas diagonais de "proibição" */}
          {Array.from({ length: 10 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                position: "absolute",
                width: "200%",
                height: "4px",
                background: theme.palette.error.main,
                opacity: 0.2,
                transform: `rotate(${45 + index * 10}deg)`,
                top: `${index * 15}%`,
                left: "-50%",
              }}
            />
          ))}

          {/* Conteúdo principal */}
          <Box
            sx={{
              zIndex: 2,
              width: "90%",
              maxWidth: 500,
              bgcolor: "rgba(0, 0, 0, 0.7)",
              p: 4,
              borderRadius: 3,
              boxShadow: 4,
              textAlign: "center",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: theme.palette.error.main,
                fontWeight: "bold",
                textShadow: `0px 0px 10px ${theme.palette.error.main}, 0px 0px 20px ${theme.palette.error.light}`,
                animation: "glow 1.5s infinite alternate",
              }}
              gutterBottom
            >
              401
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: "#fff",
                fontWeight: "bold",
                mb: 2,
              }}
              gutterBottom
            >
              Acesso Negado
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#ddd",
                mb: 3,
              }}
              gutterBottom
            >
              Você não tem permissão para acessar esta página.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/login")}
              sx={{
                textTransform: "uppercase",
                fontWeight: "bold",
                boxShadow: 2,
                "&:hover": {
                  boxShadow: 4,
                  transform: "scale(1.02)",
                },
                transition: "all 0.3s ease",
              }}
            >
              Voltar para o Login
            </Button>
          </Box>

          {/* Keyframes para animações */}
          <style>
            {`
              @keyframes glow {
                0% { text-shadow: 0px 0px 10px ${theme.palette.error.main}; }
                100% { text-shadow: 0px 0px 20px ${theme.palette.error.light}; }
              }
            `}
          </style>
        </Box>
      </ThemeProviderWrapper>
    </ThemeModeProvider>
  );
};

export default UnauthorizedPage;
